import { createContext } from 'react';

import type {
  BuscaApuracaoDetalhadaItem,
  BuscaApuracaoDetalhadaSaidas,
  BuscaApuracaoDetalhadaTotais,
  FiltrosApuracaoDetalhada,
} from '@/services/ApuracaoDetalhada';

type ResumoMensal = {
  credito: { ibs: number; cbs: number };
  debito: { ibs: number; cbs: number };
  /** Estorno de crédito (baixa de estoque por perda): reduz o crédito do período. */
  estorno: { ibs: number; cbs: number };
  saldo: { ibs: number; cbs: number };
};

export type ApuracaoDetalhadaContextValue = {
  selecaoMensalValida: boolean;
  buscaAplicada: boolean;
  filtrosAplicados: FiltrosApuracaoDetalhada;

  handleBuscar: () => void;
  handleLimparFiltrosGlobais: () => void;

  apuracaoLista: BuscaApuracaoDetalhadaItem[];
  apuracaoTotais?: BuscaApuracaoDetalhadaTotais;
  apuracaoSaidas?: BuscaApuracaoDetalhadaSaidas | null;
  resumoMensal: ResumoMensal;
  isLoadingTabela: boolean;

  isCredito: (tipo?: string) => boolean;
  isEstorno: (tipo?: string) => boolean;
  normalizeAliquota: (raw: number) => number;
};

export const ApuracaoDetalhadaContext = createContext<ApuracaoDetalhadaContextValue | null>(null);
